import { UsersService } from '@client/services/users';

// Truthy with no >=400 status is success; a cancelled request resolves undefined.
const ok = (res) => !!res && !(res.status >= 400);

export const runners = {
  reminder: async (selected) => ok(await UsersService.sendReminder({ emails: selected.map(({ email }) => email) })),
  cache: async (user) => (await UsersService.clearCache({ email: user.email })) === 'Empty',
  disable: async (user) =>
    ok(await UsersService.updateUser({ email: user.email, removed: true, updateType: 'removed' }))
};
